"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFileBytes = readFileBytes;
exports.fileExists = fileExists;
exports.getFileName = getFileName;
exports.listDirectory = listDirectory;
exports.resolvePath = resolvePath;
const core_1 = require("@tauri-apps/api/core");
function readFileBytes(path) {
    return __awaiter(this, void 0, void 0, function* () {
        const base64 = yield (0, core_1.invoke)('read_file_base64', { path });
        const binary = atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes.buffer;
    });
}
function fileExists(path) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, core_1.invoke)('file_exists', { path });
    });
}
function getFileName(path) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, core_1.invoke)('get_file_name', { path });
    });
}
function listDirectory(path) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, core_1.invoke)('list_directory', { path });
    });
}
function resolvePath(relative) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, core_1.invoke)('resolve_path', { relative });
    });
}
